/**
 * בסיס URL ל-API – בשרת (server/src/app.js) כל הראוטים תחת ‎/api/...
 * ב־localhost: חובה ‎/api‎ (same-origin) כדי ש-Vite יעביר ל־‎localhost:5001‎ (ראו vite.config.js proxy).
 * בפרודקשן: ‎VITE_API_URL‎ או ברירת מחדל ל־api.reshet.app.
 */
export function getApiBaseUrl() {
  const raw = (import.meta.env.VITE_API_URL || "").trim();
  const fallback = "https://api.reshet.app/api";

  const isLocalDev =
    typeof window !== "undefined" &&
    /^localhost$|^127\.0\.0\.1$/i.test(window.location.hostname || "");

  if (raw.startsWith("/")) {
    return raw.replace(/\/+$/, "") || "/api";
  }

  if (!raw) {
    return isLocalDev ? "/api" : fallback;
  }

  const base = raw.replace(/\/+$/, "");
  if (/\/api$/i.test(base)) return base;

  try {
    const u = new URL(base);
    const path = (u.pathname || "/").replace(/\/+$/, "") || "/";
    if (path === "/") {
      return `${u.origin}/api`;
    }
  } catch {
    return `${base}/api`;
  }

  return base;
}
